export const FEATURE_NAME = '@zerops/zerops/features/gitlab-repo-form';
